import React from 'react'
import styled from 'styled-components'

import i18n from 'live/services/i18n'

const DetailsInfo = ({ data, goBack }) => {
    const opt = {
        label: data?.b?.degraded ? i18n('DEGRADED BARRIER') : i18n('ACTIVE BARRIER'),
        icon: data?.b?.degraded ? 'exclamation-triangle' : 'check-circle',
        color: data?.b?.degraded ? '#C43535' : '#01C292'
    }
    const typeName = { threats: i18n('PREVENTION'), consequences: i18n('MITIGATION') }
    const critical = data?.a?.isCritical ? i18n('Critical') : i18n('Non-Critical')
    // const barrierType = {human: ''}

    return (
        <DetailsInfoContainer colorBar={data?.type == 'prevention' ? '#53DBB9' : '#EDA96A'}>
            <header className="DetailsInfo_header">
                <button onClick={goBack}>
                    <i className="far fa-chevron-left"></i>
                    {/* {data[index]?.id} */}
                    {data?.name}
                </button>
                <h4 className="DetailsInfo_header-title">{data?.a?.description}</h4>
                <small className="DetailsInfo_header-subtitle" style={{ color: data?.type && opt.color }}>
                    <i className={`far fa-${data?.type && opt.icon}`}></i>
                    {data?.type && opt.label} <span className="Bowtie_pipe">|</span>
                    <span className="Barrier_type">{i18n(typeName[data?.type])}</span>
                </small>
            </header>
            <section className="DetailsInfo_body">
                <ul className="DetailsInfo_body_list">
                    <li className="DetailsInfo_body_list-item">
                        <span className="DetailsInfo_body_list-item_title">{i18n('Barrier Type')}</span>
                        <span className="DetailsInfo_body_list-item_value">{i18n(data?.a?.type)}</span>
                    </li>
                    <li className="DetailsInfo_body_list-item">
                        <span className="DetailsInfo_body_list-item_title">{i18n('Responsible')}</span>
                        <span className="DetailsInfo_body_list-item_value">{data?.a?.responsible}</span>
                    </li>
                    <li className="DetailsInfo_body_list-item">
                        <span className="DetailsInfo_body_list-item_title">{i18n('Criticality')}</span>
                        <span className="DetailsInfo_body_list-item_value">{i18n(critical)}</span>
                    </li>
                    <li className="DetailsInfo_body_list-item">
                        <span className="DetailsInfo_body_list-item_title">{i18n('Activities or Systems')}</span>
                        <span className="DetailsInfo_body_list-item_value">{data?.a?.activities}</span>
                    </li>
                    <li className="DetailsInfo_body_list-item">
                        <span className="DetailsInfo_body_list-item_title">{i18n('Initial Frequency')}</span>
                        <span className="DetailsInfo_body_list-item_value">{data?.b?.frequency?.toExponential(2)}</span>
                    </li>
                    <li className="DetailsInfo_body_list-item">
                        <span className="DetailsInfo_body_list-item_title">{i18n('Current Frequency')}</span>
                        <span className="DetailsInfo_body_list-item_value">
                            {data?.b?.usedFrequency?.toExponential(2)}
                        </span>
                    </li>
                </ul>
            </section>
        </DetailsInfoContainer>
    )
}

export default DetailsInfo

const DetailsInfoContainer = styled.section<{ colorBar: string }>`
    height: 100%;

    padding: 16px;

    background: #fff;

    .DetailsInfo_header {
        & button {
            cursor: pointer;
            margin: 0;
            padding: 0;
            appearance: none;
            border: none;
            outline: none;
            background: none;
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            line-height: 16px;
            color: #37a3ef;
            i {
                margin-right: 6px;
            }
        }

        .DetailsInfo_header-title {
            margin: 16px 0 6px 0;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            display: flex;
            align-items: center;
            text-transform: uppercase;
            color: #364159;
        }
        .DetailsInfo_header-subtitle {
            margin-bottom: 16px;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            display: flex;
            align-items: center;
            text-transform: uppercase;
            i {
                margin-right: 6px;
            }

            .Barrier_type {
                padding: 4px;
                border-radius: 4px;
                background: ${props => props?.colorBar};
                color: #fff;
            }
        }
    }

    .DetailsInfo_body {
        &,
        .DetailsInfo_body_list,
        .DetailsInfo_body_list-item {
            display: flex;
            flex-direction: column;
        }
        .DetailsInfo_body_list-item {
            &:not(:last-child) {
                border-bottom: 1px solid #dddee1;
            }
            padding: 16px 0;

            .DetailsInfo_body_list-item_title {
                margin-bottom: 8px;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                color: #364159;
            }
            .DetailsInfo_body_list-item_value {
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                color: #364159;
                text-transform: capitalize;
            }
        }
    }

    .Bowtie_pipe {
        margin: 0 6px;
    }
`
